import { $, on } from '../lib/domUtils'

function heroScrollDown() {
  on($('#scroll-down-hero'), 'click', () => {
    document
      .getElementById('scroll-down-hero')
      .scrollIntoView({ behavior: 'smooth', inline: 'nearest' })
  })
}

heroScrollDown()
